import React from 'react';
import { BasicInfo, VentaDetails, AlquilerDetails, InvestmentSummary } from './scenario-details';

const formatCurrency = value => {
    if (!value || isNaN(value)) return '0 €';
    return parseFloat(value).toLocaleString('es-ES', { 
        minimumFractionDigits: 0, 
        maximumFractionDigits: 2 
    }) + ' €';
};

const ScenarioDetailsModal = ({ isOpen, scenario, onClose, onShowCostesExtra, onCargarCostesVacacional, costesVacacional }) => {
    if (!isOpen || !scenario) return null;

    const { scenarioName, constructor, costeReforma, costesExtra, venta, alquiler } = scenario;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl p-6 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-bold text-gray-800">
                        Detalles: {scenarioName} - {constructor}
                    </h2>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700 text-2xl"
                    >
                        ×
                    </button>
                </div>
                
                <div className="space-y-4">
                    {/* Basic Info */}
                    <BasicInfo 
                        costeReforma={costeReforma} 
                        costesExtra={costesExtra} 
                        onShowCostesExtra={onShowCostesExtra}
                        onCargarCostesVacacional={onCargarCostesVacacional}
                        costesVacacional={costesVacacional}
                    />

                    {/* Venta Details */}
                    {venta && <VentaDetails venta={venta} />}

                    {/* Alquiler Details */}
                    {alquiler && alquiler.precioMensualEstimado && (
                        <AlquilerDetails alquiler={alquiler} />
                    )}

                    {/* Investment Summary */}
                    <InvestmentSummary 
                        costeReforma={costeReforma} 
                        costesExtra={costesExtra} 
                        propiedadId={scenario.propiedadId}
                    />
                </div>
            </div>
        </div>
    );
};

export default ScenarioDetailsModal; 